/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

import {Component, inject} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community'; // NOSONAR
import {IxModule} from '@siemens/ix-angular';
import {Router} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';

import {User} from '../../../../models/User';
import {ListUserComponent} from './list-user.component';

@Component({
  imports: [IxModule, TranslateModule],
  template: `
    @if (user) {
      <div class="d-flex justify-content-end">
        @if (user['status'] !== 'initial') {
          <ix-icon-button
            class="m-1"
            icon="pen"
            id="editCellRendererEditButton.{{ user['email'] }}"
            oval
            variant="subtle-primary"
            (click)="onEditClick()"
          ></ix-icon-button>
        }
        <ix-icon-button
          class="m-1"
          icon="trashcan"
          id="editCellRendererDeleteButton.{{ user['email'] }}"
          oval
          variant="subtle-primary"
          (click)="onDeleteClick()"
        />
      </div>
    }
  `,
})
export class EditCellRendererComponent implements ICellRendererAngularComp {
  readonly router = inject(Router);

  listUserComponent?: ListUserComponent;

  public user!: User;

  agInit(params: ICellRendererParams): void {
    this.listUserComponent = params.context.listUserComponent;
    this.user = params.data;
  }

  refresh(): boolean {
    return false;
  }

  reloadCurrentPage() {
    this.listUserComponent?.loadUserList();
  }

  async onEditClick() {
    await this.router.navigate(['/app/edit-user', this.user['id']]);
  }

  async onDeleteClick() {
    await this.listUserComponent?.onDeleteClick(this.user);
  }
}
